const state = {
  drawerOpen: false
};

const getters = {};

const mutations = {
  setDrawerOpen(state, value) {
    state.drawerOpen = value;
  }
};

export default {
  state,
  getters,
  mutations,
  namespaced: true
};
